import connector from '@/utils/Connection'

export default {
  actions: {
    async getDoctorsReasons ({dispatch, commit},) {
      const result = await connector.getDoctorsReasonsList();
      this.state.lastResponse = result;
      if (result.error == 0) {
        this.state.doctorsReasonsList = result.data;
      }
      return result;
    }
  }
}